import * as USER_TYPES from "constants/USER_TYPES"

export const userName = ( user ) => {
    const {
        user_type = USER_TYPES.TYPE_DOCTOR,
        last_name,
        name = "",
        middle_name
    } = user

    if( user_type == USER_TYPES.TYPE_DOCTOR )
    {
        return (`${ last_name } ${ name } ${ middle_name }`).trim()
    } else {
        return name
    }
}